import { useState } from "react";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";
import { api, apiErr } from "@/lib/api";
import { Button } from "@/components/Button";
import { Modal, Field, TextInput, TextArea } from "@/components/Modal";

export function ContactSupportModal({ open, onClose }) {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const close = () => { onClose(); setTimeout(() => { setSent(false); setForm({ name: "", email: "", message: "" }); }, 300); };

  const submit = async () => {
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) return toast.error("Please fill in all fields.");
    setBusy(true);
    try { await api.post("/support/public", form); setSent(true); }
    catch (e) { toast.error(apiErr(e)); }
    finally { setBusy(false); }
  };

  return (
    <Modal open={open} onClose={close} title="Contact Support" testId="contact-support-modal"
      footer={sent
        ? <Button full onClick={close} data-testid="contact-support-done">Done</Button>
        : <><Button variant="secondary" full onClick={close}>Cancel</Button><Button full loading={busy} onClick={submit} data-testid="contact-support-submit">Send</Button></>}>
      {sent ? (
        <div className="text-center py-4" data-testid="contact-support-success">
          <CheckCircle2 className="mx-auto text-emerald-400 mb-3" size={40} />
          <p className="text-slate-100 font-medium">Thanks, we got your message.</p>
          <p className="text-slate-400 text-sm mt-1.5">InfoKeepSake Admin will reach out by email. (Check your Spam/Junk folder too.)</p>
        </div>
      ) : (
        <>
          <p className="text-slate-400 text-sm mb-4">Can't log in or need help with your account? Tell us who you are and we'll get back to you by email.</p>
          <Field label="Name"><TextInput value={form.name} onChange={set("name")} placeholder="Your name" data-testid="contact-support-name" /></Field>
          <Field label="Email"><TextInput type="email" value={form.email} onChange={set("email")} placeholder="The email on your account" data-testid="contact-support-email" /></Field>
          <Field label="What do you need help with?"><TextArea rows={4} value={form.message} onChange={set("message")} placeholder="e.g. I can't log in to my account" data-testid="contact-support-message" /></Field>
        </>
      )}
    </Modal>
  );
}
